import React, { useState } from 'react';
import { Dropdown } from 'antd';

import StyledButton from 'app/components/StyledButton';
import { ReactComponent as FilterIcon } from 'app/assets/img/filter-icon.svg';
import { StyledStack } from 'app/components/Stack';
import ApprovalOrderSearch, { SearchProps } from './Search';

interface MobileSearchProps extends SearchProps {}

const MobileSearch: React.FC<MobileSearchProps> = props => {
  const [menuVisible, setMenuVisible] = useState(false);
  const { agentData, approvalOrderFilter, onChangeFilter, onSubmitFilter } =
    props;

  return (
    <Dropdown
      visible={menuVisible}
      trigger={['click']}
      onVisibleChange={visible => setMenuVisible(visible)}
      getPopupContainer={trigger => trigger.parentNode as HTMLElement}
      overlayStyle={{ zIndex: 3 }}
      overlay={
        <StyledStack
          style={{
            background: 'white',
            width: 292,
            padding: 16,
            borderRadius: 10,
            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
          }}
        >
          <ApprovalOrderSearch
            approvalOrderFilter={approvalOrderFilter}
            onChangeFilter={onChangeFilter}
            onSubmitFilter={onSubmitFilter}
            agentData={agentData}
          />
        </StyledStack>
      }
    >
      <StyledButton
        bgColor="#fff"
        style={{
          border: '1px solid #EDEDED',
          borderRadius: 10,
          width: 41,
          height: 41,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
      >
        <FilterIcon width={16} height={16} color="#000" />
      </StyledButton>
    </Dropdown>
  );
};

export default MobileSearch;
